import { render, staticRenderFns } from "./FieldAutocomplete.vue?vue&type=template&id=923122be&"
import script from "./FieldAutocomplete.vue?vue&type=script&lang=js&"
export * from "./FieldAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {VAutocomplete})
